export enum BasePaths {
  CONTACT = '/contact/*',
  COSTING_PROFILE = '/costing-profile/*',
  DASHBOARD = '/dashboard/*',
  JOB = '/job/*',
  ORDER = '/order/*',
  PART = '/part/*',
  PRICING_PROFILE = '/pricing-profile/*',
  PROJECT = '/project/*',
  QUOTE = '/quote/*',
  REPORT = '/reports/*',
  SUPPORT_REQUEST = '/support/request/*',
}
